import { createSelector } from 'redux-bundler'

const FIREBASE_CONNECTED = 'FIREBASE_CONNECTED'
const FIREBASE_DISCONNECTED = 'FIREBASE_DISCONNECTED'
const FIREBASE_AUTHED = 'FIREBASE_AUTHED'
const FIREBASE_AUTHENTICATING = 'FIREBASE_AUTHENTICATING'
export const FIREBASE_TOKEN_FAILED = 'FIREBASE_TOKEN_FAILED'

export default fb => ({
  name: 'firebase',
  selectFirebaseState: state => state.firebase,
  selectFirebaseConnected: state => state.firebase.connected,
  selectFirebaseAuthed: state => state.firebase.authed,
  selectFirebaseAuthUserId: createSelector('selectFirebaseAuthed', fbAuthed => {
    const { currentUser } = fb.auth()
    return currentUser && currentUser.uid
  }),
  doFirebaseAuth: fbToken => ({ dispatch }) => {
    dispatch({ type: FIREBASE_AUTHENTICATING })
    fb
      .auth()
      .signInWithCustomToken(fbToken)
      .then(user => {
        dispatch({ type: FIREBASE_AUTHED })
      })
      .catch(error => {
        if (error.code === 'auth/invalid-custom-token') {
          dispatch({ type: FIREBASE_TOKEN_FAILED })
        }
      })
  },
  getReducer: () => {
    const initialState = {
      connected: false,
      authed: !!fb.auth().currentUser,
      disconnectedAt: null,
      connectedAt: null,
      loggingIn: false
    }
    return (state = initialState, { type }) => {
      if (type === FIREBASE_DISCONNECTED) {
        return Object.assign({}, state, {
          connected: false,
          disconnectedAt: Date.now()
        })
      }
      if (type === FIREBASE_CONNECTED) {
        return Object.assign({}, state, {
          connected: true,
          connectedAt: Date.now()
        })
      }
      if (type === FIREBASE_AUTHED) {
        return Object.assign({}, state, {
          authed: true,
          loggingIn: false
        })
      }
      if (type === FIREBASE_TOKEN_FAILED) {
        return Object.assign({}, state, {
          authed: false,
          loggingIn: false
        })
      }
      if (type === FIREBASE_AUTHENTICATING) {
        return Object.assign({}, state, {
          loggingIn: true
        })
      }
      return state
    }
  },
  init: store => {
    fb
      .database()
      .ref('.info/connected')
      .on('value', snap => {
        if (snap.val()) {
          store.dispatch({ type: FIREBASE_CONNECTED })
        } else if (store.selectFirebaseConnected()) {
          store.dispatch({ type: FIREBASE_DISCONNECTED })
        }
      })
  },
  reactShouldAuthFirebase: createSelector(
    'selectFirebaseToken',
    'selectFirebaseState',
    (token, fb) => {
      if (token && !fb.authed && !fb.loggingIn) {
        return { actionCreator: 'doFirebaseAuth', args: [token] }
      }
    }
  )
})
